import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconUser: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-2-stroke-1.5-IconUser"><Path d="M15.7822 12.2246C18.2767 13.4193 20 15.9666 20 18.917C19.9998 20.0673 19.0673 20.9998 17.917 21H6.08301C4.93267 20.9998 4.00018 20.0673 4 18.917C4 15.967 5.72273 13.4195 8.2168 12.2246C9.26706 13.0246 10.5779 13.5 12 13.5C13.4218 13.5 14.7321 13.0243 15.7822 12.2246Z" fill="currentColor"/><Path d="M12 2.5C14.6234 2.5 16.75 4.62665 16.75 7.25C16.75 9.87335 14.6234 12 12 12C9.37665 12 7.25 9.87335 7.25 7.25C7.25 4.62665 9.37665 2.5 12 2.5Z" fill="currentColor"/></CentralIconBase>;
});

export default IconUser;
